var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',_vm._l((_vm.content),function(section){return _c('div',{key:section.id},[_vm._t("section",function(){return [(section.contentType)?_c(section.contentType,_vm._b({tag:"component",attrs:{"id":section.handle}},'component',section.data,false)):_vm._e()]},{"section":section})],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }